import React from 'react';
import styled from 'styled-components';
import { dfdDefaultTheme, MuiBox } from 'theme/material-ui';
import {
  calcCardDimensions,
  CalcHeightProps
} from 'components/DashboardCarousel/DashboardBannerCard';
import { useWindowSize } from 'hooks/useWindowSize';
import useVisibleSlidesCount from 'hooks/useVisibleSlidesCount';
import { Color } from 'modules/styles/colors';
import {
  Slider as PRCSlider,
  Slide as PRSlide,
  CarouselProvider as PRCarouselProvider,
  Dot as PRDot
} from 'pure-react-carousel';

interface SliderWidthProps {
  windowWidth: number;
  totalCards: number;
  visibleSlides: number;
}

const calcSliderWidth = (props: SliderWidthProps) => {
  if (props.totalCards === 1) {
    return '925px';
  }
  if (props.totalCards > 1) {
    if (props.visibleSlides === 1) {
      return '100%';
    }
    if (props.visibleSlides === 2) {
      return '1100px';
    }
    if (props.visibleSlides === 3) {
      return '100%';
    }
  }
  return '100%';
};

export const SliderBox = styled(MuiBox)`
  width: ${(props: SliderWidthProps) => calcSliderWidth(props)};
`;

interface SliderBoxContainerProps {
  totalCards: number;
  children: React.ReactNode;
}

export const SliderBoxContainer = ({ totalCards, children }: SliderBoxContainerProps) => {
  const visibleSlides = useVisibleSlidesCount(totalCards);
  const windowDim = useWindowSize();

  return (
    <SliderBox totalCards={totalCards} visibleSlides={visibleSlides} windowWidth={windowDim.width}>
      {children}
    </SliderBox>
  );
};

export const Slider = styled(({ sliderHeight, ...rest }) => <PRCSlider {...rest} />)`
  height: ${props => `${props.sliderHeight}px`};
  width: ${(props: SliderWidthProps) => calcSliderWidth(props)};
  max-width: 1650px;
`;

export const Slide = styled(PRSlide)`
  & .carousel__inner-slide {
    padding: 0 ${dfdDefaultTheme.spacing(1)}px;
  }

  ${dfdDefaultTheme.breakpoints.down('md')} {
    & .carousel__inner-slide {
      padding: 0;
    }
  }
`;

export const DotContainer = styled(MuiBox)`
  position: absolute;
  bottom: -35px;
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Dot = styled(PRDot)`
  border: none;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  margin: 3px;

  &.carousel__dot {
    background-color: ${Color.grayLight};
  }

  &.carousel__dot--selected {
    background-color: ${Color.tealOriginal};
  }
`;

export const CarouselProvider = styled(PRCarouselProvider)`
  height: ${(props: CalcHeightProps) => calcCardDimensions(props).height};
  width: 100%;
  display: flex;
  justify-content: center;
`;
